import React, { FC } from 'react';
import { Modal } from 'shared/ui/modal/modal';
import cls from './drawer.module.scss';
import { ICONS } from 'shared/constants/images';
import IconButton from 'shared/ui/iconButton/icon-button';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  width?: number;
  children: React.ReactNode;
  className?: string;
}

export const Drawer: FC<DrawerProps> = ({
  isOpen,
  onClose,
  title,
  width = 800,
  children,
  className,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant='drawer'
      drawerWidth={width}
      className={className}
    >
      <div className={cls.header}>
        {title && <h3>{title}</h3>}
        <IconButton
          onClick={onClose}
          aria-label='Close'
          pathToIcon={ICONS.crossBlack}
        />
      </div>
      <div className={cls.content}>{children}</div>
    </Modal>
  );
};

export default Drawer;
